import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { providesThreadResolutionControls } from '../dataSync'
import { record as ThreadsRecord } from 'data/threads'

import Text from 'components/base/Text'

class ThreadResolver extends Component {
  static propTypes = {
    resolveThread: PropTypes.func.isRequired,
    unresolveThread: PropTypes.func.isRequired,
    thread: PropTypes.instanceOf(ThreadsRecord).isRequired,
  }

  toggleIsArchived = () => {
    const { resolveThread, unresolveThread, thread } = this.props

    if (thread.resolvedAt) {
      unresolveThread({ threadId: thread.id })
    } else {
      resolveThread({ threadId: thread.id })
    }
  }

  render() {
    const { thread, className, children, onCloseThread } = this.props

    let content = children
    if (!children) {
      content = thread.resolvedAt ? 'Unresolve' : 'Mark as resolved'
    }

    return (
      <Text.Action
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          this.toggleIsArchived()
          if (!thread.resolvedAt) {
            onCloseThread()
          }
        }}
        className={className}
      >
        {content}
      </Text.Action>
    )
  }
}

export default providesThreadResolutionControls(ThreadResolver)
